"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Anania, Anushavan on 12/7/2016.
 */
var core_1 = require("@angular/core");
var lodash_1 = require("lodash");
require("rxjs/add/observable/combineLatest");
require("rxjs/add/operator/publishReplay");
var Observable_1 = require("rxjs/Observable");
var hierarchical_meta_category_id_1 = require("../model/hierarchical-meta-category-id");
var meta_category_1 = require("../model/meta-category");
var meta_category_id_1 = require("../model/meta-category-id");
var meta_category_offline_1 = require("../model/meta-category-offline");
var meta_field_1 = require("../model/meta-field");
var meta_field_id_1 = require("../model/meta-field-id");
var meta_group_1 = require("../model/meta-group");
var meta_group_id_1 = require("../model/meta-group-id");
var meta_field_type_helper_1 = require("./meta-field-type-helper");
var KbDeserializationHelper = /** @class */ (function () {
    function KbDeserializationHelper() {
        this.SYSTEM_GROUP_SYSTEM_NAME = 'systemGroup';
    }
    KbDeserializationHelper.prototype.extractCategories = function (responseData, categoryType, extractOfflineFeatures) {
        var categories;
        switch (categoryType) {
            case CategoryType.MAIN_ENTITY: {
                categories = responseData.filter(function (item) { return item.getIsWithVersioning(); });
                break;
            }
            case CategoryType.CLASSIFIER: {
                categories = responseData.filter(function (item) { return item.getIsClassifier(); });
                break;
            }
            case CategoryType.CATEGORY_MANAGER: {
                categories = responseData.filter(function (item) { return lodash_1.isNil(item.getShowInCategoryManager()) ? item.getIsClassifier() :
                    item.getShowInCategoryManager(); });
                break;
            }
            default: {
                categories = responseData;
            }
        }
        return categories.sort(this.systemNameComparator);
    };
    KbDeserializationHelper.prototype.extractHierarchicalCategories = function (responseData) {
        var _this = this;
        var categories = [];
        responseData.forEach(function (category) {
            categories.push(_this.extractHierarchicalCategory(category));
        });
        return categories;
    };
    KbDeserializationHelper.prototype.extractHierarchicalCategory = function (categoryItem) {
        var _this = this;
        var children = [];
        categoryItem.child.forEach(function (child) {
            children.push(_this.extractHierarchicalCategory(child));
        });
        return new hierarchical_meta_category_id_1.HierarchicalMetaCategoryId(categoryItem.data.systemName, categoryItem.isRoot, children);
    };
    KbDeserializationHelper.prototype.extractGroups = function (metaFields$, categoryGroups, excludeSystemMetaGroup) {
        var _this = this;
        return metaFields$
            .map(function (allMetaFields) {
            var displayName;
            var metaFields;
            var metaGroups = [];
            // let categoryGroups: Array<any> = data[1].body ? data[1].body : data[1];
            categoryGroups.forEach(function (categoryGroup) {
                if (!excludeSystemMetaGroup || categoryGroup.systemName !== _this.SYSTEM_GROUP_SYSTEM_NAME) {
                    metaFields = [];
                    var systemName = categoryGroup.systemName;
                    var displayNameMultilingual = categoryGroup.displayNameMultilingual;
                    displayName = categoryGroup.displayName ?
                        categoryGroup.displayName : '';
                    categoryGroup.metaFieldIds.forEach(function (item) {
                        allMetaFields.forEach(function (metaField) {
                            if (metaField.getSystemName() === item.systemName) {
                                metaFields.push(metaField);
                            }
                        });
                    });
                    metaGroups.push(new meta_group_1.MetaGroup(systemName, displayName, metaFields, displayNameMultilingual));
                }
            });
            return metaGroups;
        })
            .catch(this.handleError);
    };
    KbDeserializationHelper.prototype.extractFields = function (categorySystemName, response) {
        var _this = this;
        return response.map(function (item) {
            return _this.extractField(categorySystemName, item);
        });
    };
    KbDeserializationHelper.prototype.extractMetaFieldId = function (metaFieldIdJson) {
        var name = metaFieldIdJson.systemName;
        var categorySystemName = metaFieldIdJson.metaCategoryId.systemName;
        var groupSystemName = metaFieldIdJson.groupId != null ?
            metaFieldIdJson.groupId.systemName :
            null;
        return new meta_field_id_1.MetaFieldId(new meta_category_id_1.MetaCategoryId(categorySystemName), name, new meta_group_id_1.MetaGroupId(groupSystemName));
    };
    KbDeserializationHelper.prototype.extractCategory = function (item, extractOfflineFeatures) {
        var _this = this;
        var categorySystemName = item.metaCategoryId.systemName;
        var displayNameMsgId = item.displayName;
        var hasCustomCategory = item.hasCustomSorting;
        var isCacheable = item.isCacheable;
        var metaCategoryId = new meta_category_id_1.MetaCategoryId(categorySystemName);
        var wfProcessId = item.wfProcessId;
        var hasIcon = item.hasIcon ? item.hasIcon : false;
        var isWithVersioning = item.isWithVersioning ?
            item.isWithVersioning : false;
        var isClassifier = item.isClassifier ? item.isClassifier :
            false;
        var nameMetaFieldIds = item.nameMetaFieldIds.map(function (metaFieldIdJson) {
            return _this.extractMetaFieldId(metaFieldIdJson);
        });
        var keyMetaFieldIds = item.keyMetaFieldIds.map(function (metaFieldIdJson) {
            return _this.extractMetaFieldId(metaFieldIdJson);
        });
        var actionDataMetaFieldIds = item.actionDataMetaFieldIds
            ?
                item.actionDataMetaFieldIds.map(function (metaFieldIdJson) {
                    return _this.extractMetaFieldId(metaFieldIdJson);
                })
            : [];
        if (!extractOfflineFeatures) {
            return new meta_category_1.MetaCategory(metaCategoryId, displayNameMsgId, hasCustomCategory, hasIcon, '', wfProcessId, isCacheable, nameMetaFieldIds, isWithVersioning, isClassifier, keyMetaFieldIds, actionDataMetaFieldIds);
        }
        var identityMetaFieldId = this.extractMetaFieldId(item.identityMetaFieldId);
        var instanceMetaFieldId = item.instanceMetaFieldId ?
            this.extractMetaFieldId(item.instanceMetaFieldId) :
            null;
        var isSearchable = item.isSearchable;
        var searchableMetaFieldIds = [];
        item.searchableFieldIds.forEach(function (metaFieldIdJson) {
            searchableMetaFieldIds.push(_this.extractMetaFieldId(metaFieldIdJson));
        });
        return new meta_category_offline_1.MetaCategoryOffline(metaCategoryId, displayNameMsgId, hasCustomCategory, identityMetaFieldId, instanceMetaFieldId, isSearchable, searchableMetaFieldIds, false, '', wfProcessId, isCacheable, isWithVersioning, isClassifier, nameMetaFieldIds, keyMetaFieldIds, actionDataMetaFieldIds);
    };
    KbDeserializationHelper.prototype.extractField = function (categorySystemName, item) {
        var metaFieldTypeHelper = new meta_field_type_helper_1.MetaFieldTypeHelper();
        var name = item.metaFieldId.systemName;
        var metaFieldId = this.extractMetaFieldId(item.metaFieldId);
        var isMultiline = item.isMultiline;
        var maxLength = item.maxLength;
        var displayName = item.displayName ? item.displayName : name;
        var type = metaFieldTypeHelper.getMetaFieldType(item.metaFieldType);
        var typeStr = item.metaFieldType;
        var fieldPrefix = item.fieldPrefix;
        var compoundCategorySystemName = this.isCompoundField(type) ?
            this.extractCategorySystemName(item, type) : null;
        var displayNameMultilingual = item.displayNameMultilingual;
        return new meta_field_1.MetaField(metaFieldId, displayName, type, typeStr, isMultiline, compoundCategorySystemName, maxLength, fieldPrefix, item.isSystemField, displayNameMultilingual, item.isActionDataField);
    };
    KbDeserializationHelper.prototype.extractCategorySystemName = function (item, type) {
        switch (type) {
            case meta_field_1.MetaFieldType.PARENT: {
                return item.parentMetaCategoryId.systemName;
            }
            case meta_field_1.MetaFieldType.CLASSIFIER:
            case meta_field_1.MetaFieldType.MULTI_SELECT: {
                return item.classifierMetaCategoryId.systemName;
            }
            case meta_field_1.MetaFieldType.SUB_ENTITY: {
                return item.subEntityMetaCategoryId.systemName;
            }
            case meta_field_1.MetaFieldType.MAIN_ENTITY: {
                return item.mainEntityCategoryId.systemName;
            }
            case meta_field_1.MetaFieldType.WORKFLOW_STATE: {
                return item.workflowStateMetaCategoryId.systemName;
            }
            case meta_field_1.MetaFieldType.LOOKUP: {
                return item.lookupMetaCategoryId.systemName;
            }
            default: {
                throw new Error("Unsupported compound field type " + type);
            }
        }
    };
    KbDeserializationHelper.prototype.systemNameComparator = function (item1, item2) {
        var systemName1 = item1.metaCategoryId.systemName.toLowerCase();
        var systemName2 = item2.metaCategoryId.systemName.toLowerCase();
        return systemName1 < systemName2 ? -1 :
            systemName1 > systemName2 ? 1 : 0;
    };
    KbDeserializationHelper.prototype.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText :
                'Server error';
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    KbDeserializationHelper.prototype.isCompoundField = function (fieldType) {
        return fieldType === meta_field_1.MetaFieldType.CLASSIFIER || fieldType === meta_field_1.MetaFieldType.MULTI_SELECT
            || fieldType === meta_field_1.MetaFieldType.MAIN_ENTITY || fieldType === meta_field_1.MetaFieldType.SUB_ENTITY
            || fieldType === meta_field_1.MetaFieldType.WORKFLOW_STATE || fieldType === meta_field_1.MetaFieldType.PARENT
            || fieldType === meta_field_1.MetaFieldType.LOOKUP;
    };
    KbDeserializationHelper = __decorate([
        core_1.Injectable()
    ], KbDeserializationHelper);
    return KbDeserializationHelper;
}());
exports.KbDeserializationHelper = KbDeserializationHelper;
var CategoryType;
(function (CategoryType) {
    CategoryType[CategoryType["ALL"] = 0] = "ALL";
    CategoryType[CategoryType["MAIN_ENTITY"] = 1] = "MAIN_ENTITY";
    CategoryType[CategoryType["CLASSIFIER"] = 2] = "CLASSIFIER";
    CategoryType[CategoryType["CATEGORY_MANAGER"] = 3] = "CATEGORY_MANAGER";
})(CategoryType = exports.CategoryType || (exports.CategoryType = {}));
//# sourceMappingURL=kb-deserialization-helper.js.map